import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite, IDB_rowWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_IRoutedUnitsSet } from '../Type/Type.hive'

export function IDB_routedUnitRead(id: number) {
    return IDB_rowRead<Type_IRoutedUnitsSet>(IDB_globalDb, 'routed_units', id)
}

export function IDB_routedUnitsDelete(ids: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'routed_units', ids)
}

export function IDB_routedUnitsReadAll() {
    return IDB_rowsReadAll<Type_IRoutedUnitsSet>(IDB_globalDb, 'routed_units')
}

export function IDB_routedUnitsWrite(routedUnits: Type_IRoutedUnitsSet[]) {
    return IDB_rowsWrite(IDB_globalDb, 'routed_units', routedUnits)
}

export function IDB_routedUnitWrite(routedUnit: Type_IRoutedUnitsSet) {
    return IDB_rowWrite(IDB_globalDb, 'routed_units', routedUnit)
}
